import { render, staticRenderFns } from "./WinPoints.vue?vue&type=template&id=2439f992&"
import script from "./WinPoints.vue?vue&type=script&lang=js&"
export * from "./WinPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports